import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'savingsinterest'
})
export class SavingsinterestPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value == "1") {
      return "Upfront";
    }
    if (value == "2") {
      return "Periodic";
    }
    if (value == "3") {
      return "Backend";
    } 
  }

}
